import { handleRequest } from "../utilities/requestHandler";

export const getProductMachines = (req_body) =>
    handleRequest("post","/products/getproductmachines", req_body);